import { NgModule } from '@angular/core';

import { SharedModule } from 'src/app/shared/shared.module';

import { AcceptableUseComponent } from './acceptable-use/acceptable-use.component';
import { AccountComponent } from './account/account.component';
import { AddAddressComponent } from './account/add-address/add-address.component';
import { BootstrapThemeKitComponent } from './bootstrap-theme-kit/bootstrap-theme-kit.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { CookiesComponent } from './cookies/cookies.component';
import { EditMyPetComponent } from './my-pets/my-pet/edit/edit-my-pet.component';
import { ForgotPasswordComponent } from './account/forgot-password/forgot-password.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './account/login/login.component';
import { LoginRegisterComponent } from './account/login-register/login-register.component';
import { SocialLandingPageComponent } from './social-landing-page/social-landing-page.component';
import { LostAndFoundComponent } from './lost-and-found/lost-and-found.component';
import { MicrochippingYourPetComponent } from './microchipping-your-pet/microchipping-your-pet.component';
import { MissingPetComponent } from './lost-and-found/missing-pets/missing-pet/missing-pet.component';
import { MissingPetsComponent } from './lost-and-found/missing-pets/missing-pets.component';
import { MyPetComponent } from './my-pets/my-pet/my-pet.component';
import { MyPetsComponent } from './my-pets/my-pets.component';
import { PerkTermsComponent } from './perk-terms/perk-terms.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { RegisterComponent } from './account/register/register.component';
import { ClaimPetByChipComponent } from './my-pets/claim-pet/claim-by-chip/claim-by-chip.component';
import { RegisterUserDetailsConfirmationComponent } from './account/register/user-details-confirmation/user-details-confirmation.component';
import { ReportMissingPetComponent } from './my-pets/my-pet/report-missing/report-missing.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { UpdateAddressComponent } from './account/update-address/update-address.component';
import { UpdateEmailComponent } from './account/update-email/update-email.component';
import { UpdatePasswordComponent } from './account/update-password/update-password.component';
import { UpdateTelephoneComponent } from './account/update-telephone/update-telephone.component';
import { UpgradeAccountComponent } from './account/upgrade-account/upgrade-account.component';
import { WebsiteUseComponent } from './website-use/website-use.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SetNewPasswordComponent } from './account/set-new-password/set-new-password.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { QrCodePageComponent } from './qr-code/qr-code-page.component';
import { InvoicesComponent } from './account/invoices/invoices.component';
import { ActivateEmailComponent } from './account/activate-email/activate-email.component';
import { SentEmailComponent } from './account/sent-email/sent-email.component';
import { OwnerDetailsComponent } from './account/owner-details/owner-details.component';
import { ClaimAccountComponent } from './account/claim-account/claim-account.component';
import { MembershipOptionsComponent } from './account/membership-options/membership-options.component';
import { PetplanWelcomePackComponent } from './petplan-application/petplan-welcome-gift/petplan-welcome-gift.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IdentibaseSubAppreciationComponent } from './account/identibase-sub-appreciation/identibase-sub-appreciation.component';
import { ActivateNoEmailUserComponent } from './account/activate-no-email-user/activate-no-email-user.component';
import { IdentibasePlusPageComponent } from '../shared/components/subscription-pages/identibasePlus/identibase-plus-page.component';
import { IdentialertPageComponent } from '../shared/components/subscription-pages/identialert/identialert-page.component';
import { IdentifindPageComponent } from '../shared/components/subscription-pages/identifind/identifind-page.component';
import { SocialLoginRegisterComponent } from './account/social-login-register/social-login-register.component';
import { RehomePetComponent } from './my-pets/rehome-pet/rehome-pet.component';
import { ChoosePlanComponent } from './choose-plan/choose-plan.component';
import { UpdateDateOfBirthComponent } from './account/update-date-of-birth/update-date-of-birth.component';
import { UpdateGenderComponent } from './account/update-gender/update-gender.component';
import { UpdateTitleComponent } from './account/update-title/update-title.component';
import { PitPatPageComponent } from '../shared/components/subscription-pages/pitpat/pitpat-page.component';
import { QrCodePreferencesPageComponent } from './qr-code/preferences/qr-code-preferences-page.component';
import { PetDeceasedComponent } from './qr-code/pet-deceased/pet-deceased.component';
import { CheckPetsChipComponent } from './check-pets-chip/check-pets-chip.component';
import { PurinaCheckChipComponent } from './purina-check-chip/purina-check-chip.component';
import { TokClaimAccountComponent } from './account/tok-register/tok_claim_account.component';
import { TokLoginComponent } from './account/tok-login/tok-login.component';
import { TokPaymentComponent } from './tok-payment/tok-payment.component';
import { TokDetailsComponent } from './tok-details/tok-details.component';
import { IdentiProfessionalsComponent } from './identi-professionals/identi-professionals.component';
import { IdentibaseReviewComponent } from './identibase-review/identibase-review.component';
import { MissingPetReportComponent } from './lost-and-found/missing-pets/missing-pet-report/missing-pet-report.component';
import { TokConsentComponent } from './tok-consent/tok-consent.component';

@NgModule({
  declarations: [
    AcceptableUseComponent,
    AccountComponent,
    AddAddressComponent,
    BootstrapThemeKitComponent,
    ContactUsComponent,
    CookiesComponent,
    DashboardComponent,
    EditMyPetComponent,
    ForgotPasswordComponent,
    HomeComponent,
    InvoicesComponent,
    LoginComponent,
    LoginRegisterComponent,
    LostAndFoundComponent,
    MicrochippingYourPetComponent,
    MissingPetComponent,
    MissingPetsComponent,
    MissingPetReportComponent,
    MyPetComponent,
    MyPetsComponent,
    NotFoundComponent,
    QrCodePageComponent,
    QrCodePreferencesPageComponent,
    PerkTermsComponent,
    PrivacyComponent,
    RegisterComponent,
    ClaimPetByChipComponent,
    RegisterUserDetailsConfirmationComponent,
    ReportMissingPetComponent,
    SetNewPasswordComponent,
    TermsAndConditionsComponent,
    UpdateAddressComponent,
    UpdateEmailComponent,
    UpdatePasswordComponent,
    UpdateTelephoneComponent,
    UpdateDateOfBirthComponent,
    UpdateGenderComponent,
    UpdateTitleComponent,
    UpgradeAccountComponent,
    WebsiteUseComponent,
    ActivateEmailComponent,
    SentEmailComponent,
    OwnerDetailsComponent,
    ClaimAccountComponent,
    MembershipOptionsComponent,
    PetplanWelcomePackComponent,
    IdentibaseSubAppreciationComponent,
    ActivateNoEmailUserComponent,
    IdentibasePlusPageComponent,
    IdentialertPageComponent,
    IdentifindPageComponent,
    PitPatPageComponent,
    SocialLoginRegisterComponent,
    ChoosePlanComponent,
    SocialLandingPageComponent,
    RehomePetComponent,
    PetDeceasedComponent,
    CheckPetsChipComponent,
    PurinaCheckChipComponent,
    TokClaimAccountComponent,
    TokLoginComponent,
    TokLoginComponent,
    TokPaymentComponent,
    TokDetailsComponent,
    IdentiProfessionalsComponent,
    IdentibaseReviewComponent,
    TokConsentComponent,
  ],
  imports: [SharedModule, ReactiveFormsModule, FormsModule],
})
export class PagesModule {}

export const RoutingComponents = {
  AcceptableUseComponent,
  AccountComponent,
  AddAddressComponent,
  BootstrapThemeKitComponent,
  ContactUsComponent,
  CookiesComponent,
  DashboardComponent,
  EditMyPetComponent,
  ForgotPasswordComponent,
  HomeComponent,
  InvoicesComponent,
  LoginComponent,
  LoginRegisterComponent,
  LostAndFoundComponent,
  MicrochippingYourPetComponent,
  MissingPetComponent,
  MissingPetsComponent,
  MissingPetReportComponent,
  MyPetsComponent,
  MyPetComponent,
  NotFoundComponent,
  QrCodePageComponent,
  QrCodePreferencesPageComponent,
  PerkTermsComponent,
  PrivacyComponent,
  RegisterComponent,
  ClaimPetByChipComponent,
  RegisterUserDetailsConfirmationComponent,
  ReportMissingPetComponent,
  SetNewPasswordComponent,
  TermsAndConditionsComponent,
  UpdateAddressComponent,
  UpdateEmailComponent,
  UpdatePasswordComponent,
  UpdateTelephoneComponent,
  UpdateDateOfBirthComponent,
  UpdateGenderComponent,
  UpdateTitleComponent,
  UpgradeAccountComponent,
  WebsiteUseComponent,
  ActivateEmailComponent,
  SentEmailComponent,
  OwnerDetailsComponent,
  ClaimAccountComponent,
  MembershipOptionsComponent,
  PetplanWelcomePackComponent,
  IdentibaseSubAppreciationComponent,
  ActivateNoEmailUserComponent,
  IdentibasePlusPageComponent,
  IdentialertPageComponent,
  IdentifindPageComponent,
  PitPatPageComponent,
  SocialLoginRegisterComponent,
  ChoosePlanComponent,
  SocialLandingPageComponent,
  RehomePetComponent,
  PetDeceasedComponent,
  CheckPetsChipComponent,
  PurinaCheckChipComponent,
  TokClaimAccountComponent,
  TokLoginComponent,
  TokPaymentComponent,
  TokDetailsComponent,
  IdentiProfessionalsComponent,
  IdentibaseReviewComponent,
  TokConsentComponent
};
